import { useFormContext } from 'react-hook-form';

import {
  IncomeSourceFormT,
  PAY_AMOUNT_MIN,
  payAmountValidations,
} from '@consumer-frontend/nc-utils';

import { NcInput } from '../NcInput';

export type NcIncomeSourceAmountFieldPropsT = {
  label: string;
};

export type NcIncomeSourceAmountFieldT = React.FC<NcIncomeSourceAmountFieldPropsT>;

export const NcIncomeSourceAmountField: NcIncomeSourceAmountFieldT = ({
  label,
}) => {
  const { register, formState: { errors } } = useFormContext<IncomeSourceFormT>();

  const amountFieldOptions = {
    ...payAmountValidations,
    valueAsNumber: true,
  };

  return (
    <NcInput
      {...register('amount', amountFieldOptions)}
      errorMessage={errors.amount?.message}
      id="pay-amount-input"
      label={label}
      min={PAY_AMOUNT_MIN}
      prefix="$"
      step={PAY_AMOUNT_MIN}
      type="number"
    />
  );
};
